export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#262626] bg-[#0a0a0a] pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-7 h-7 bg-[#d92d20] flex items-center justify-center font-display font-extrabold text-sm">
                A
              </span>
              <span className="font-display font-extrabold tracking-tight text-[15px]">
                DR. CJ AVORY
              </span>
            </div>
            <p className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-[-0.03em] leading-[0.95] max-w-2xl">
              Preparation is the only thing
              <br />
              <span className="text-[#d92d20]">that survives the crisis.</span>
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4">Site</div>
            <ul className="space-y-3 text-sm">
              {[
                ["About", "#about"],
                ["Book", "#book"],
                ["Consulting", "#consulting"],
                ["Speaking", "#speaking"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="text-white/70 hover:text-white link-underline">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:info@kismetleads.com"
                  className="text-white/70 hover:text-white link-underline"
                >
                  info@kismetleads.com
                </a>
              </li>
              <li>
                <a
                  href="https://a.co/d/09ek9ufb"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white link-underline"
                >
                  Decision Margin on Amazon
                </a>
              </li>
              <li className="text-white/55">United States</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#262626] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/45 font-mono uppercase tracking-[0.18em]">
            © {new Date().getFullYear()} Dr. Cj Avory · Kismet Leads, LLC
          </p>
          <p className="text-xs text-white/45 font-mono uppercase tracking-[0.18em]">
            Crisis Leadership · Resilience · Decision Margin
          </p>
        </div>
      </div>
    </footer>
  );
}
